import { Component, Inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
} from '@angular/material/dialog';
import { PricingTemplate } from '../../../models';
export interface PricingTemplatesDialogDeleteWarningComponentData {
    action: string;
    data: PricingTemplate[]
}

@Component({
    selector: 'app-pricing-templates-delete-warning-template',
    styleUrls: ['./pricing-template-dialog-delete-warning.component.scss'],
    templateUrl: './pricing-template-dialog-delete-warning.component.html',
})
export class PricingTemplatesDialogDeleteWarningComponent {
    public selectedTemplate: any;

    constructor(
        public dialogRef: MatDialogRef<PricingTemplatesDialogDeleteWarningComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: PricingTemplatesDialogDeleteWarningComponentData,
    ) {
        dialogRef.disableClose = true;
    }

    onSelect() {
        if (this.selectedTemplate) {
            this.dialogRef.close(this.selectedTemplate);
        }
    }

    public onCancelClick(): void {
        this.dialogRef.close('cancel');
    }
}
